/* eslint-disable @typescript-eslint/member-ordering */
import {
   ChangeDetectionStrategy,
   ChangeDetectorRef,
   Component,
   EventEmitter,
   Inject,
   Input,
   Output,
   ViewChild,
} from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { Store, select } from '@ngrx/store';

import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeviceTypes } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { DeviceSelectComponent } from 'src/app/common-components/entity-select/phone/component/device-select-component';
import { PhoneDetailView } from '../../add-phone/models/phone-detail-view.model';
import { PhoneDetailFormService } from '../../add-phone/services/phone-detail-form.service';
import { getAddPhoneCallState } from '../../add-phone/state/add-phone.selectors';
import { AddHardphoneData } from '../models/add-hardphone-data.model';

@Component({
   changeDetection: ChangeDetectionStrategy.OnPush,
   selector: 'ndt-add-hardphone-view',
   templateUrl: './add-hardphone-view.component.html',
   standalone: false,
})
export class AddHardphoneViewComponent {
   @ViewChild(DeviceSelectComponent, { static: false })
   deviceSelectComponent: DeviceSelectComponent;

   @Output() formCanceled = new EventEmitter<void>();

   @Input() accountId: number;

   form: UntypedFormGroup;

   phone: PhoneDetailView;

   DeviceTypes = DeviceTypes;

   callState$: Observable<CallState>;

   constructor(
      private controlContainer: ControlContainer,
      protected store: Store,
      private changeDetectorRef: ChangeDetectorRef,
      protected formService: PhoneDetailFormService,
      private parentForm: FormGroupDirective,
      @Inject(MAT_DIALOG_DATA) public data: AddHardphoneData
   ) {
      this.accountId = data.accountId;
      this.phone = {
         devices: data.devices ?? [],
         extensionId: data.extensionId,
         phoneId: data.phoneId ?? 0,
         numberOfLineKeys: data.numberOfLineKeys,
         phoneTypeId: data.phoneType,
         sipUsers: [],
         baseStationHandsets: [],
         handsetIpei: '',
         sipUserMetaData: [],
      };

      this.callState$ = this.store.pipe(select(getAddPhoneCallState));
      this.form = this.formService.form;
      this.formService.updatePhone(this.phone);
   }

   ngOnInit(): void {
      this.form = <UntypedFormGroup>this.controlContainer.control;
   }

   ngAfterViewInit(): void {
      setTimeout(() => {
         this.deviceSelectComponent?.refresh();
      });
   }

   ngDoCheck(): void {
      if (this.form.invalid && this.parentForm.submitted) {
         this.form.markAllAsTouched();
         this.changeDetectorRef.markForCheck();
      }
   }

   get hardphoneGroup(): UntypedFormGroup {
      return this.form.get('hardphoneGroup') as UntypedFormGroup;
   }

   showPassword = false;

   // Passed to the `keyvalue` pipe in the template so form.controls (an index-keyed dictionary)
   // renders in its original order instead of the pipe's default alphabetical key sort.
   preserveControlOrder(): number {
      return 0;
   }

   onCloseClick(): void {
      this.formCanceled.emit();
   }
}
